import { Term } from './model/term.model';
import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { DataOrigin } from '../../model/DataOrigin';
import { TermsDataService } from './termos-data.service';
import { TermsMockService } from './terms-data-mock.service';
import { TermsDataMobileService } from './terms-data-mobile.service';

@Injectable({
  providedIn: 'root',
})
export abstract class TermsFactoryService {
  private services = new Map<DataOrigin, TermsDataService>();

  constructor(private handlerService: HandlerService) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): TermsDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new TermsDataMobileService(this.handlerService);
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new TermsMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new TermsMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
